import { dbsliceData } from './dbsliceData.js';

function getFilteredTaskIds() {

	return dbsliceData.filteredTaskIds;

}

export { getFilteredTaskIds };

